import { render, staticRenderFns } from "./PetInsuranceItem.vue?vue&type=template&id=08cd9664&scoped=true&"
import script from "./PetInsuranceItem.vue?vue&type=script&lang=js&"
export * from "./PetInsuranceItem.vue?vue&type=script&lang=js&"
import style0 from "./PetInsuranceItem.vue?vue&type=style&index=0&id=08cd9664&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cd9664",
  null
  
)

export default component.exports